module.exports = __webpack_public_path__ + "img/fullscreen-icon.7054f997.svg";